import { BRAND_SIZE_OVERRIDES } from "constants/action-types";
import { handleActions } from "redux-actions";
import { ISizeOverride } from "../containers/management/management-types";

const initialState = {
    sizeOverrides: [],
    isAdding: false,
    isDeleting: false,
    isFetching: false,
    isUpdating: false,
    sizeOverridesError: undefined,
};

interface IState {
    sizeOverrides: ISizeOverride[];
    isAdding: boolean;
    isFetching: boolean;
    isUpdating: boolean;
    sizeOverridesError: any;
}

export const brandSizeOverrides = handleActions(
    {
        [BRAND_SIZE_OVERRIDES.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [BRAND_SIZE_OVERRIDES.FETCH.SUCCESS]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                sizeOverrides: payload,
                isFetching: false,
            };
        },
        [BRAND_SIZE_OVERRIDES.FETCH.ERROR]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                isFetching: false,
                sizeOverridesError: payload.error,
            };
        },
        [BRAND_SIZE_OVERRIDES.CREATE.START]: (state: IState): IState => {
            return {
                ...state,
                isAdding: true,
            };
        },
        [BRAND_SIZE_OVERRIDES.CREATE.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    isAdding: false,
                    sizeOverridesError: error,
                };
            }
            return {
                ...state,
                sizeOverrides: [...state.sizeOverrides, payload],
                isAdding: false,
            };
        },
        [BRAND_SIZE_OVERRIDES.DELETE.START]: (state: IState) => {
            return {
                ...state,
                isDeleting: true,
            };
        },
        [BRAND_SIZE_OVERRIDES.DELETE.COMPLETED]: (state: IState, { payload, error }: any) => {
            if (error) {
                return {
                    ...state,
                    familiesError: payload.error,
                    isDeleting: false,
                };
            }
            const { _id } = payload;
            return {
                ...state,
                sizeOverrides: state.sizeOverrides.filter((f) => f._id !== _id),
                isDeleting: false,
            };
        },
        [BRAND_SIZE_OVERRIDES.UPDATE.START]: (state: IState) => {
            return {
                ...state,
                isUpdating: true,
            };
        },
        [BRAND_SIZE_OVERRIDES.UPDATE.COMPLETED]: (state: IState, { payload, error }: any) => {
            if (error) {
                return {
                    ...state,
                    familiesError: payload.error,
                    isUpdating: false,
                };
            }
            const sizeOverrides = state.sizeOverrides.slice();
            const index = sizeOverrides.findIndex((f) => f._id === payload._id);
            sizeOverrides.splice(index, 1, payload);

            return {
                ...state,
                sizeOverrides,
                isUpdating: false,
            };
        },
    },
    initialState
);
